import{gql as e}from"@apollo/client";const p=e`
  mutation updateGroupMembership($request: UpdateGroupMembershipInputType!) {
    membership {
      updateGroupMembership(request: $request) {
        id
      }
    }
  }
`;export{p as UPDATE_GROUP_MEMBERSHIP_MUTATION};
//# sourceMappingURL=useUpdateGroupMembership.graphql.js.map
